import {
  BookingListQueryVariables,
  BookingRelocationMatchType,
  BookingStatus,
  OrderByRelationWithColumnAggregateFunction,
  QueryBookingsOrderByCancelledByActivityColumn,
  QueryBookingsOrderByColumn,
  SortOrder,
} from "@/gql/graphql";
import { BookingSortOption } from "@/app/Bookings/Screens/BookingListScreen";

export function getBookingListQueryVariables(
  {
    bookingStatus,
    search,
    hasMatches,
    orderByOption,
  }: {
    bookingStatus?: BookingStatus[];
    search?: string;
    hasMatches?: BookingRelocationMatchType | null;
    orderByOption?: BookingSortOption;
  },
  supplierId: string | null,
): BookingListQueryVariables {
  const baseParams: BookingListQueryVariables = {
    first: 20,
    page: 1,
    status: bookingStatus?.length ? bookingStatus : undefined,
    supplierId: supplierId ?? undefined,
    search: search || undefined,
  };

  if (search) {
    return baseParams;
  }

  const orderBy: BookingListQueryVariables["orderBy"] = [
    {
      column: QueryBookingsOrderByColumn.Id,
      order: SortOrder.Desc,
    },
  ];
  if (orderByOption === "newest" || orderByOption === undefined) {
    //do nothing
  } else if (orderByOption === "recently_cancelled") {
    orderBy.unshift({
      cancelledByActivity: {
        column: QueryBookingsOrderByCancelledByActivityColumn.CreatedAt,
        aggregate: OrderByRelationWithColumnAggregateFunction.Max,
      },
      order: SortOrder.Desc,
    });
  } else if (orderByOption === "recently_confirmed") {
    orderBy.unshift({
      column: QueryBookingsOrderByColumn.ConfirmedAt,
      order: SortOrder.Desc,
    });
  }

  return {
    ...baseParams,
    hasMatches: hasMatches || undefined,
    orderBy,
  };
}
